import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app" }

import { onMounted } from 'vue'
import SonglistTool from '@/views/SonglistTool/Main.vue'
import AppBar from '@/components/bars/AppBar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  document.title = "Makruu.com | SonglistTool"
})

return (_ctx: any,_cache: any) => {
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_app, null, {
      default: _withCtx(() => [
        _createVNode(AppBar),
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            _createVNode(SonglistTool)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})